import { render, staticRenderFns } from "./SelectorsComponent.vue?vue&type=template&id=4355cba0&scoped=true&"
import script from "./SelectorsComponent.vue?vue&type=script&lang=js&"
export * from "./SelectorsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectorsComponent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SelectorsComponent.vue?vue&type=style&index=1&id=4355cba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4355cba0",
  null
  
)

export default component.exports